import { CUSTOMER_COUNTRY } from './quoteWizardState';
import type { UsStateCode } from '@/enterprise/components/InstantPay/usStates';

export interface QuoteEntity {
  id: string;
  name: string;
  street?: string;
  city?: string;
  state?: UsStateCode;
  zip?: string;
}

interface QuoteAddressParts {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
}

/** One line in the frame's order: street, city, state and zip, then country. Missing parts are left out. */
export const formatQuoteAddress = (address: QuoteAddressParts): string => {
  const stateAndZip = [address.state, address.zip].filter(Boolean).join(' ');
  return [address.street, address.city, stateAndZip, CUSTOMER_COUNTRY.name].filter(Boolean).join(', ');
};

/**
 * Stand-in for the customer catalog the quote flow will eventually search. Names are stable
 * fixtures the step tests match on; the address parts are sample data, not a real catalog.
 * Northgate has no zip and Summit Ridge has no street so a partial match has something to ask for.
 */
export const QUOTE_ENTITY_CATALOG: QuoteEntity[] = [
  {
    id: 'entity-tandem',
    name: 'Tandem Logistics LLC',
    street: '411 Harrow Ave',
    city: 'Omaha',
    state: 'NE',
    zip: '68102',
  },
  {
    id: 'entity-harbor',
    name: 'Harbor and Pine Supply',
    street: '88 Market St',
    city: 'Portland',
    state: 'ME',
    zip: '04101',
  },
  {
    id: 'entity-redbird',
    name: 'Redbird Manufacturing',
    street: '2200 Commerce Dr',
    city: 'Austin',
    state: 'TX',
    zip: '78701',
  },
  {
    id: 'entity-northgate',
    name: 'Northgate Foods',
    street: '15 Lakeview Rd',
    city: 'Cleveland',
    state: 'OH',
  },
  {
    id: 'entity-summit',
    name: 'Summit Ridge Wholesale',
    city: 'Denver',
    state: 'CO',
    zip: '80202',
  },
  {
    id: 'entity-lumen',
    name: 'Lumen Paper Co',
    street: '640 Industrial Pkwy',
    city: 'Buffalo',
    state: 'NY',
    zip: '14202',
  },
  {
    id: 'entity-copperline',
    name: 'Copperline Metals',
    street: '901 Foundry St',
    city: 'Pittsburgh',
    state: 'PA',
    zip: '15222',
  },
  {
    id: 'entity-brightwater',
    name: 'Brightwater Packaging',
    street: '77 Wharf Ln',
    city: 'Oakland',
    state: 'CA',
    zip: '94607',
  },
];

export const findQuoteEntities = (query: string): QuoteEntity[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return [];
  return QUOTE_ENTITY_CATALOG.filter((entity) => entity.name.toLowerCase().includes(normalized));
};
